import { render, staticRenderFns } from "./trabalheConosco.vue?vue&type=template&id=f7f14ac0&scoped=true"
import script from "./trabalheConosco.vue?vue&type=script&lang=js"
export * from "./trabalheConosco.vue?vue&type=script&lang=js"
import style0 from "./trabalheConosco.vue?vue&type=style&index=0&id=f7f14ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f14ac0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
